module.exports = __webpack_public_path__ + "static/media/image.4712d6aa.png";